const JAPAN_POSTAL_CODE_REGEXP = /(\d{7})|(\d{3}-\d{4})/;
function extractJapanPostalCode(text) {
  return text.match(JAPAN_POSTAL_CODE_REGEXP)?.[0];
}
export {
  extractJapanPostalCode
};
//# sourceMappingURL=postal-code.js.map
